export default __webpack_public_path__ + "static/media/reactback.c40cfda6.svg";